import React, { FC } from 'react';
import { Box, Chip } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

type TransportDateProps = {
    date: Date;
    label: string;
};

const TransportDate: FC<TransportDateProps> = ({ date, label }: TransportDateProps) => {
    const { t: translate } = useTranslation(['transport', 'country-names']);

    return (
        <Box display="flex" alignItems="center">
            <Box mr={1}>
                <Chip sx={{ minWidth: 80 }} label={label} />
            </Box>
            <Box mr={1} flex="1 0 auto">
                <Box>{translate(`${moment(date).format('ddd')}, ${moment(date).format('YYYY-MM-DD')}`)}</Box>
            </Box>
        </Box>
    );
};

export default TransportDate;
